var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prices",class:this.$isPC ? '' : 'sp-prices'},[(_vm.items.length > 0)?_c('div',[_c('form-campaign-price'),_vm._v(" "),_c('div',{staticClass:"price-list"},_vm._l((_vm.items),function(item,index){return _c('price',{key:index,attrs:{"item":item}})}),1)],1):_c('div',[_vm._v("ただいま商品を準備中です。")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-751f0900","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Prices.vue
// module id = null
// module chunks = 